import React, { Component } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Button } from "reactstrap";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class JournalPdf extends Component {
  state = { numPages: null };

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };

  render() {
    const { pdfUrl } = this.props;
    const { numPages } = this.state;

    return (
      <div width={{ width: '100%' }} ref={(node) => this.pdfDocument = node}>
        <Document
          file={pdfUrl}
          onLoadSuccess={this.onDocumentLoadSuccess}

        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page key={index} pageNumber={index + 1} width={this.pdfDocument ? this.pdfDocument.clientWidth : null} />
          ))}
        </Document>

        {/* <div style={{ marginTop: "10px" }}>
          <a href={pdfUrl} download target="_blank" rel="noopener noreferrer">
              <Button type="button" className="button-blue">{'Download PDF'.translate(lang)}</Button>
          </a>
        </div> */}
      </div>
    );
  }
}

export default JournalPdf;
